import React, { useState } from "react";
import Modal from "../../Modal";
import { useDispatch } from "react-redux";
import { createTopic, getTopic } from "../../../features/slices/topicSlice";
import { useLocation } from "react-router-dom";
import { toastService } from "../../../utils/toastify";

const CreateTopic = ({ setShowTopic, categoryId }) => {
  const [topicName, setTopicName] = useState("");
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { state } = useLocation();
  const handleClose = () => {
    setShowTopic((prev) => ({ ...prev, add: false }));
  };
  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!topicName?.trim()) {
      formErrors.topicName = "topic name is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };
  const handleCreateTopic = async () => {
    const data = {
      topicName,
      categoryId: state,
    };
    if (validateForm()) {
      const res = await dispatch(createTopic(data));
      if (res?.payload?.code == 200) {
        toastService.success("Topic added successfully");
        dispatch(getTopic({ page: 1, categoryId: state }));
        handleClose();
      } else {
        toastService.error("Topic creation failed");
      }
    }
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Category">
          <a className="CloseModal" onClick={handleClose}>
            ×
          </a>
          <h3>Create New Topic</h3>
          <div className="form-group">
            <label>Topic Name</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Topic name"
              value={topicName}
              onChange={(e) => {
                setErrors("");
                setTopicName(e.target.value);
              }}
            />
            {errors.topicName && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.topicName}
              </p>
            )}
          </div>
          <button className="Button" onClick={handleCreateTopic}>
            Create New Topic
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default CreateTopic;
